.cvv-input {
  width: 88px;
  margin-left: 8px;

  .cvv label {
    font-size: 12px;
    font-weight: 400;
  }
}
